import { preprocess } from '@artica/assets';
import {
  Color,
  SphereGeometry,
  MeshBasicMaterial,
  MeshPhysicalMaterial,
} from 'three';

preprocess('dyson', function preprocessDyson(gltf) {
  const { materials } = gltf;
  
  gltf.perfectSphereGeometry = new SphereGeometry(
    7.075427614991359,
    16,
    16,
  );

  materials.godraymat = new MeshBasicMaterial({
    color: 0xffddaa,
    transparent: true,
    fog: false,
  });

  materials.flockingmat = materials.default = new MeshPhysicalMaterial({
    color: 0x000000,
    ior: 2,
    roughness: 0.4,
    reflectivity: 0,
    transparent: true,
    thickness: 10.1,
    emissiveIntensity: 0.05,
    emissive: new Color(1, 0.2, 0),
    fog: false,
    specularIntensity: 2.5,
  });

  return gltf;
});